import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-admin-hinzufuegen-multi';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichAdminHinzufuegenMultiEffects {

    FunktionsbereichAdminHinzufuegenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_ADMIN_HINZUFUEGEN_MULTI),
        mergeMap((x: ac.PostFunktionsbereichAdminHinzufuegenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichAdminHinzufuegenMulti(x.funktionsbereichBenutzerMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichAdminHinzufuegenMultiErfolgreichAction(result, x.funktionsbereichBenutzerMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichAdminHinzufuegenMultiFehlerAction(error, x.funktionsbereichBenutzerMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
